/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgCopilotColorful = (props)=>/*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            width: 23,
            height: 23
        },
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M8.196 1.922 3.5 4.634A3 3 0 0 0 2 7.232v5.536a3 3 0 0 0 1.5 2.598l2.267 1.31L5.99 16l4.247-2.543L8.5 12.453A3 3 0 0 1 7 9.855V8.273l.466-.593L9 6.492V3l-.676-.988-.739.527c.171-.232.376-.44.61-.617Z",
        fill: "url(#CopilotColorful_svg__a)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.196 1.922 3.5 4.634A3 3 0 0 0 2 7.232v5.536a3 3 0 0 0 1.5 2.598l2.267 1.31L5.99 16l4.247-2.543L8.5 12.453A3 3 0 0 1 7 9.855V8.273l.466-.593L9 6.492V3l-.676-.988-.739.527c.171-.232.376-.44.61-.617Z",
        fill: "url(#CopilotColorful_svg__b)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M12.999 7.615v2.24a3 3 0 0 1-1.5 2.599l-5 2.887a3 3 0 0 1-3 0l-.304-.175c.097.073.198.14.303.2l5 2.889a3 3 0 0 0 3.001 0l5-2.888a3 3 0 0 0 1.5-2.598v-2.081l-5-3.073Z",
        fill: "url(#CopilotColorful_svg__c)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M12.999 7.615v2.24a3 3 0 0 1-1.5 2.599l-5 2.887a3 3 0 0 1-3 0l-.304-.175c.097.073.198.14.303.2l5 2.889a3 3 0 0 0 3.001 0l5-2.888a3 3 0 0 0 1.5-2.598v-2.081l-5-3.073Z",
        fill: "url(#CopilotColorful_svg__d)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m8.195 1.922.305-.176a3 3 0 0 1 3 0l5 2.887A3 3 0 0 1 18 7.231v5.598a3 3 0 0 0-1.5-2.536l-5-2.887a3 3 0 0 0-3 0L7 8.272V4.318a3 3 0 0 1 1.195-2.396Z",
        fill: "url(#CopilotColorful_svg__e)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m8.195 1.922.305-.176a3 3 0 0 1 3 0l5 2.887A3 3 0 0 1 18 7.231v5.598a3 3 0 0 0-1.5-2.536l-5-2.887a3 3 0 0 0-3 0L7 8.272V4.318a3 3 0 0 1 1.195-2.396Z",
        fill: "url(#CopilotColorful_svg__f)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M2 12.83Z",
        fill: "url(#CopilotColorful_svg__g)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M2 12.83Z",
        fill: "url(#CopilotColorful_svg__h)"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "CopilotColorful_svg__a",
        x1: 9.093,
        y1: 5.828,
        x2: 4.745,
        y2: 18.487,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#AE7FE2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0078D4"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "CopilotColorful_svg__b",
        x1: 7.443,
        y1: 15.221,
        x2: 6.691,
        y2: 13.894,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#114A8B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0078D4",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "CopilotColorful_svg__d",
        x1: 15.826,
        y1: 9.847,
        x2: 15.106,
        y2: 11.002,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#493474"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#8C66BA",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "CopilotColorful_svg__f",
        x1: 7.017,
        y1: 5.565,
        x2: 8.182,
        y2: 5.565,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#114A8B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0078D4",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "CopilotColorful_svg__h",
        x1: 7.017,
        y1: 5.565,
        x2: 8.182,
        y2: 5.565,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#114A8B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0078D4",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "CopilotColorful_svg__c",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(12.44626 -2.8892 2.22564 9.58779 5.146 14.758)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.14,
        stopColor: "#D59DFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#5E438F"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "CopilotColorful_svg__e",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(-143.083 9.993 2.398) scale(11.412)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#50E6FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#436DCD"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "CopilotColorful_svg__g",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(-143.083 9.993 2.398) scale(11.412)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#50E6FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#436DCD"
    }))));
export default SvgCopilotColorful;
